"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.IPaperWrapper = void 0;
var _mui = require("@ori-ui/mui");
var _featureToggles = require("@ori/feature-toggles");
var _presentationHooks = require("@ori/presentation-hooks");
var _presentationUtils = require("@ori/presentation-utils");
var _react = require("react");
var _Toolbar = require("../../components/Toolbar");
var _variables = require("../../constants/variables");
var _utils = require("../../utils");
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable @typescript-eslint/naming-convention -- iPaper is the name of the flipbook */ // TODO -- Replace with sm when Checkout adjust the mobile breakpoint on MiniShoppingBag
const CHECKOUT_MOBILE_BREAKPOINT = 1024;
const Root = (0, _mui.styled)('div', {
    shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})((param)=>{
    let { theme, isMinibagHiddenByDefault } = param;
    return {
        background: theme.palette.common.white,
        display: 'grid',
        gridTemplateRows: "".concat(_variables.TOOLBAR_HEIGHT, " 1fr"),
        height: "calc(100dvh - ".concat(_presentationUtils.CSS_MOBILE_WITH_TOP_AREA_BANNER_HEIGHT, ")"),
        maxWidth: '100%',
        position: 'fixed',
        top: _presentationUtils.CSS_MOBILE_WITH_TOP_AREA_BANNER_HEIGHT,
        width: '100vw',
        zIndex: 1,
        [theme.breakpoints.up(CHECKOUT_MOBILE_BREAKPOINT)]: {
            height: "calc(100dvh - ".concat(_presentationUtils.CSS_DESKTOP_WITH_TOP_AREA_BANNER_HEIGHT, ")"),
            top: _presentationUtils.CSS_DESKTOP_WITH_TOP_AREA_BANNER_HEIGHT,
            width: isMinibagHiddenByDefault ? '100vw' : "calc(100vw - var(--minibag-desktop-width, ".concat(_variables.DEFAULT_MINIBAG_WIDTH, "))")
        }
    };
});
const IPaperWrapper = exports.IPaperWrapper = /*#__PURE__*/ (0, _react.memo)((param)=>{
    let { children } = param;
    const { width } = (0, _presentationHooks.useWindowSize)({
        delay: 500
    });
    const { isFeatureEnabled } = (0, _featureToggles.useFeatureToggles)();
    (0, _react.useEffect)(()=>{
        (0, _utils.setCssVariables)();
    }, [
        children,
        width
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Root, {
        id: _utils.IPAPER_ROOT_ID,
        isMinibagHiddenByDefault: isFeatureEnabled(_utils.FEATURE_REMOVE_PERMANENT_MINIBAG_FROM_CATALOGUE),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Toolbar.Toolbar, {}),
            children
        ]
    });
});
